import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, URLSearchParams, ResponseContentType } from '@angular/http';
import { DevelopUtil } from '../../utils/develop.utils';

@Injectable()
export class CommunicationsHttpService {

  // old endpoints
  public static ALL_QUESTIONS_URL = DevelopUtil.url('quest');
  public static OPENED_QUESTIONS_URL = DevelopUtil.url('quest/opened');
  public static CLOSED_QUESTIONS_URL = DevelopUtil.url('quest/closed');
  //

  public static ALL_CHATS_URL = DevelopUtil.url('chat');
  public static COUNT_CHATS_URL = DevelopUtil.url('chat/count');
  public static INIT_CHAT_URL = DevelopUtil.url('chat/init');
  public static ATTACH_CHAT_URL = DevelopUtil.url('chat/attach/');

  private headers: Headers;
  private requestOptions: RequestOptions;

  constructor(private http: Http) {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions({headers: this.headers});
  }

  // old requests
  getQuest(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    this.requestOptions.responseType = null;
    return this.http.get(CommunicationsHttpService.ALL_QUESTIONS_URL, this.requestOptions);
  }

  getOpendQuest(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(CommunicationsHttpService.OPENED_QUESTIONS_URL, this.requestOptions);
  }

  getClosedQuest(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(CommunicationsHttpService.CLOSED_QUESTIONS_URL, this.requestOptions);
  }

  getSingleQuest(urlSearchParams: URLSearchParams, number): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(CommunicationsHttpService.ALL_QUESTIONS_URL + '/' + number + '/answer', this.requestOptions);
  }

  create(urlSearchParams: URLSearchParams): Observable<Response> {
    return this.http.post(CommunicationsHttpService.ALL_QUESTIONS_URL, urlSearchParams, this.requestOptions);
  }

  sendMessage(urlSearchParams: URLSearchParams, number): Observable<Response> {
    return this.http.post(CommunicationsHttpService.ALL_QUESTIONS_URL + '/' + number + '/answer', urlSearchParams, this.requestOptions);
  }
  //

  getCountChats(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(CommunicationsHttpService.COUNT_CHATS_URL, this.requestOptions);
  }

  createChat(formData): Observable<Response> {
    this.requestOptions.responseType = null;
    return this.http.post(CommunicationsHttpService.INIT_CHAT_URL, formData, this.requestOptions);
  }

  getChats(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    this.requestOptions.responseType = null;
    return this.http.get(CommunicationsHttpService.ALL_CHATS_URL, this.requestOptions);
  }

  getSingleChat(urlSearchParams: URLSearchParams, number): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    this.requestOptions.responseType = null;
    return this.http.get(CommunicationsHttpService.ALL_CHATS_URL + '/' + number, this.requestOptions);
  }

  getMessageAttach(urlSearchParams: URLSearchParams, messageId): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    this.requestOptions.responseType = ResponseContentType.Blob;
    return this.http.get(CommunicationsHttpService.ATTACH_CHAT_URL + messageId, this.requestOptions);
  }

  sendMessageToChat(formData, chatId): Observable<Response> {
    this.requestOptions.responseType = null;
    return this.http.post(CommunicationsHttpService.ALL_CHATS_URL + '/' + chatId + '/send', formData, this.requestOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/communications/communications.http.service.ts